import { useCallback } from 'react';
import styles from './Chip.module.scss.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Text } from '../text/Text.js';
import { MdClose, MdCheck } from '../node_modules/react-icons/md/index.js';
import classNames from 'clsx';

const sizeToTextVariant = {
  default: 'button-default',
  compact: 'button-default',
  small: 'button-small',
  'small-compact': 'button-small'
};

/** A chip represents an applied filter. */
function Chip(props) {
  const {
    children,
    className: callerClassName,
    state = 'tag',
    size = 'default',
    variant = 'default',
    tag,
    UNSAFE_active,
    UNSAFE_hover,
    UNSAFE_focus,
    icon: callerIcon,
    onRemove,
    onClick,
    disabled,
    ...rest
  } = props;
  const className = classNames('dsx-component', styles['chip'], styles[`size-${size}`], styles[`variant-${variant}`], styles[`state-${state}`], UNSAFE_active && styles[`active`], UNSAFE_hover && styles[`hover`], UNSAFE_focus && styles[`focus`], callerClassName);
  const shouldUseAriaProps = state === 'checked' || state === 'unchecked';
  const ariaProps = shouldUseAriaProps ? {
    role: 'checkbox',
    'aria-checked': state === 'checked'
  } : null;
  let iconEl = undefined;
  let tagIconEl = undefined;
  if (state === 'checked') {
    iconEl = MdCheck;
  }
  const textVariant = sizeToTextVariant[size];
  const handleClick = useCallback(() => onClick?.(), [onClick]);
  const handleRemove = useCallback(e => {
    e.stopPropagation();
    onRemove?.();
  }, [onRemove]);
  if (state === 'tag') {
    iconEl = callerIcon;
    tagIconEl = /*#__PURE__*/jsx(Text, {
      disabled,
      className: classNames(styles['remove'], styles[`size-${size}`]),
      onClick: handleRemove,
      icon: MdClose,
      variant: textVariant,
      element: "button",
      color: "inherit"
    });
  }
  return /*#__PURE__*/jsxs("button", {
    ...rest,
    ...ariaProps,
    disabled,
    onClick: handleClick,
    "data-dsx--chip": tag,
    className: className,
    children: [/*#__PURE__*/jsx(Text, {
      icon: iconEl,
      variant: textVariant,
      children: children
    }), tagIconEl]
  });
}

export { Chip };
